import { useQuery } from '@tanstack/react-query'
import { FolderOpen } from 'lucide-react'
import { vocabularyApi } from '@/api/vocabulary'
import { copy } from '@/lib/copy'
import { useSettingsStore } from '@/store/settingsStore'
import { cn } from '@/components/ui/cn'

interface CollectionFilterSelectProps {
  value?: string
  onChange: (id: string | undefined) => void
  className?: string
  testId?: string
}

export function CollectionFilterSelect({
  value,
  onChange,
  className,
  testId,
}: CollectionFilterSelectProps) {
  const nativeLanguage = useSettingsStore((s) => s.settings?.nativeLanguage ?? 'en')
  const { data: collections = [] } = useQuery({
    queryKey: ['collections', nativeLanguage],
    queryFn: () => vocabularyApi.getCollections().then((r) => r.data),
  })

  if (collections.length === 0) return null

  return (
    <div className={cn('relative min-w-0 flex-1', className)}>
      <FolderOpen className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || undefined)}
        className="h-[34px] w-full truncate rounded-md border border-border bg-background pl-8 pr-2 text-xs font-medium"
        data-testid={testId ?? 'collection-filter-select'}
        aria-label={copy.vocabulary.collectionFilterAria}
      >
        <option value="">{copy.vocabulary.allItems}</option>
        {collections.map((col) => (
          <option key={col.id} value={col.id}>
            {col.icon ? `${col.icon} ` : ''}
            {col.name} ({col.wordCount})
          </option>
        ))}
      </select>
    </div>
  )
}
